module.exports = __webpack_public_path__ + "img/icon-gift.7ef8c730.svg";